class CCWidgetUtils {
  setWidgetTotal(widget) {
    var $widget = $(widget);
    var widgetTotal = Number.parseFloat($widget.attr('data-api-total'));

    if (!widgetTotal) {
      widgetTotal = 0;
    }

    // console.log('Data Convertable Unit', $widget.data('convertable-unit'), 'Data Unit', $('.cc-widget-unit-switcher .selected-unit-button').data('unit'));

    if ($widget.data('convertable-unit') == true && $('.cc-widget-unit-switcher .selected-unit-button').data('unit') == 'imperial') {
      // console.log('Calculating imperial multiplier');
      widgetTotal *= 1.10231;
    }

    widgetTotal = widgetTotal.toFixed(0);
    $widget.attr('data-total', widgetTotal);
    $widget.attr('data-value', 0);
  }

  isInViewport(elem) {
    var elementTop = $(elem).offset().top;
    var elementBottom = elementTop + $(elem).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  incrementCounter(elem){
    var currentValue = Number.parseFloat($(elem).attr('data-value'));
    var endValue = Number.parseFloat($(elem).attr('data-total'));

    if (endValue != 0 && this.isInViewport(elem) && $(elem).attr('data-value') != endValue){
        // if (endValue - currentValue > 100000){
        //     currentValue += 5000;
        // }
        // else if (endValue - currentValue > 10000){
        //     currentValue += 500;
        // }
        // else if (endValue - currentValue > 1000){
        //     currentValue += 100;
        // }
        // else if (endValue - currentValue > 100){
        //     currentValue += 10;
        // }
        // else if (endValue - currentValue >= 1){
        //     currentValue += 1;
        // }
        // else {
        //     var endDecimal = endValue % 1;
        //     var currentDecimal = currentValue % 1;

        //     if (endDecimal - currentDecimal > 0.1) {
        //         currentValue += 0.1;
        //     }
        //     else if (endDecimal - currentDecimal > .01) {
        //         currentValue += 0.01;
        //     }
        //     else if (endDecimal - currentDecimal > .001) {
        //         currentValue += 0.001;
        //     }
        //     else {
        //         currentValue += 0.00;
        //     }

        //     currentValue = currentValue.toFixed(1);
        // }

        let increment = Math.round(endValue / 125);

        if ((currentValue + increment) > endValue) {
            currentValue = endValue;
        } else {
            currentValue += increment;
        }

        // Use commas as separators for thousands
        $(elem).attr('data-value', currentValue);
        $(elem).find('.widget-value').text(currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    var classInstance = this;

    setTimeout(function() {
      classInstance.incrementCounter(elem);
    }, 10);
  }
}

export default CCWidgetUtils;



// WEBPACK FOOTER //
// ./scripts/util/CarbonCureWidgetUtils.js